import React, {useRef} from 'react';
import classNames from 'classnames';

/* eslint-disable react/jsx-no-bind */

const CustomRadio = ({checked, children, id, name, onChange, value, extraClass, ...rest}) => {
    const inputEl = useRef(null);
    const handleClick = () => {
        if (!inputEl.current.checked) {
            inputEl.current.click();
        }
    };
    const classNamesArray = ['custom-control', 'custom-radio'];
    if (extraClass) {
        classNamesArray.push(extraClass);
    }
    return (
        <div className={classNames(classNamesArray)} onClick={handleClick}>
            <input type="radio" ref={inputEl} className="custom-control-input" id={id}
                name={name} checked={checked} value={value}
                onChange={onChange} {...rest} />
            <label className="custom-control-label" htmlFor={id}>{children}</label>
        </div>
    );
};

export default CustomRadio;
